import { render, staticRenderFns } from "./AIvsReportSummary.vue?vue&type=template&id=52ec598b"
import script from "./AIvsReportSummary.vue?vue&type=script&lang=js"
export * from "./AIvsReportSummary.vue?vue&type=script&lang=js"
import style0 from "./AIvsReportSummary.vue?vue&type=style&index=0&id=52ec598b&prod&lang=css"
import style1 from "./AIvsReportSummary.vue?vue&type=style&index=1&id=52ec598b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports